// ======================================================================
// File Name       : ServiceRecordSearch
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { Form, FormControl, Col, InputGroup, Button } from 'react-bootstrap';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import Datetime from 'react-datetime';
import SelectBox from '../../../components/SelectBox';
import { SELECT_BOX_DATA } from '../../../constants/SelectBoxData';
import { DATA_AFFIILIATION_TYPE_STR, CONTENT_QUESTION_KIND } from '../../../constants/ContentConstant';
import PaginationCustom from '../../Pagination';
import { VALIDATE_TYPE, RETURN_MAX_NUM } from '../../../constants/index';
import RenderField from '../../../utils/ReduxFormUtils';
import CustomButton from '../../button/CustomButton';

class ServiceRecordSearch extends React.Component {
  constructor(props) {
    super(props);
    this.onOpenDialog = this.onOpenDialog.bind(this);
  }

  onOpenDialog() {
    this.props.openDialog(false);
  }

  render() {
    const {
        serviceCd,
        enterpriseCd,
        selectTargetMonth,
        recordNum,
        startPosition,
        getStartEndData,
        onSearchBtnClick,
        openDialog,
        maxInfo,
        isCompany,
        systemUsageMonths,
        isSupperUserL0,
        enterpriseCdForDisplay,
        generalPurposeNumber,
        canAccessOneService,
        isServiceList,
    } = this.props;
    const isShowSelect = !canAccessOneService && (isCompany || (!isCompany && !isServiceList));

    return (
      <div>
        <Col sm={12} className="margin-top-10">
          <Form className='form-horizontal'>
            {/* Step10.2.0 START */}
            {isShowSelect && (
              <Form.Group className="form-info">
                <Col as={Form.Label} sm={3}>
                  {isCompany ? "企業名" : !isServiceList ? "サービス名" : ""}
                </Col>
                {!isCompany && (
                  <Col sm={7}>
                    <RenderField
                      type="text"
                      name="serviceCd"
                      label="サービス名"
                      value={serviceCd}
                      disabled
                    />
                  </Col>
                )}
                {isCompany && (
                  <Col sm={7}>
                    <RenderField
                      type="text"
                      name="enterpriseCd"
                      label="企業名"
                      value={enterpriseCd}
                      disabled
                    />
                  </Col>
                )}
                <Col sm={2}>
                  <Button
                    variant="primary"
                    className="btn-96 margin-left-20"
                    onClick={this.onOpenDialog}
                  >
                    {isCompany ? "企業選択" : "サービス選択"}
                  </Button>
                </Col>
              </Form.Group>
            )}
            {/* Step10.2.0 END */}
            <Form.Group className="form-info">
              <Col as={Form.Label} sm={3}>
                対象年月
              </Col>
              <Col sm={7}>
                <RenderField
                  type="selectbox"
                  name="selectTargetMonth"
                  label="対象年月"
                  value={selectTargetMonth}
                  data={systemUsageMonths}
                />
              </Col>
            </Form.Group>
            {/* #7116 START */}
            {isCompany && isSupperUserL0 && <Form.Group className="form-info">
              <Col as={Form.Label} sm={3}>
                  企業コード
              </Col>
              <Col sm={7} className="padding-top-10">
                  {enterpriseCdForDisplay}
              </Col>
            </Form.Group>}
            {isCompany && isSupperUserL0 && <Form.Group className="form-info">
              <Col as={Form.Label} sm={3}>
                  汎用請求番号
              </Col>
              <Col sm={7} className="padding-top-10">
                  {generalPurposeNumber}
              </Col>
            </Form.Group>}
            {/* #7116 END */}
            <Form.Group className="text-center">
              <Col sm={12} className="padding-left-right-clear">
                <CustomButton
                  btnStyle="btn btn-primary btn-96 margin-top-20"
                  handleClick={onSearchBtnClick}
                  text="検索"
                  iconClass="bi bi-search"
                  isDisabled={!isCompany && !serviceCd}
                />
              </Col>
            </Form.Group>
          </Form>
        </Col>
      </div>
    );
  }
}

export default ServiceRecordSearch;
